/* global Vue, gsap, ScrollTrigger */

import CldImg from './components/CldImg'
import * as breakpoints from '@params'
gsap.registerPlugin(ScrollTrigger)

const MobileApp = Vue.createApp({
  name: 'MobileApp',
  components: { CldImg },
  template: '#mobile-app-template',

  setup () {
    const isIOS = Vue.ref(false)
    const isAndroid = Vue.ref(false)
    const isOtherOS = Vue.ref(false)

    const userAgent = navigator.userAgent || window.opera
    if (/iPad|iPhone/.test(userAgent) && !window.MSStream) {
      isIOS.value = true
    }
    if (/android/i.test(userAgent)) {
      isAndroid.value = true
    }

    if (!isIOS.value && !isAndroid.value) {
      isOtherOS.value = true
    }

    const accordions = Vue.ref(null)
    const showMoreButton = Vue.ref(null)

    function showMore () {
      showMoreButton.value.classList.add('is-hidden')

      const hiddenItems = accordions.value.querySelectorAll('.is-hidden')
      hiddenItems.forEach(item => item.classList.remove('is-hidden'))
    }

    Vue.onMounted(() => {
      const mediaRule = `(min-width: ${breakpoints.xl}px)`
      // const tl = gsap.timeline()

      ScrollTrigger.matchMedia({
        [mediaRule]: function () {
          gsap.to('.layout-mobile-app__phone--fixed', {
            width: 380,
            height: 776,
            paddingTop: 0,
            marginBottom: -776,
            scrollTrigger: {
              trigger: '.layout-mobile-app__stores',
              start: 'top 50%',
              end: 'bottom top',
              scrub: true,
            },
          })
          gsap.from('.layout-mobile-app__phone--fixed video', {
            borderRadius: 100,
            scrollTrigger: {
              trigger: '.layout-mobile-app__stores',
              start: 'top 50%',
              end: 'bottom top',
              scrub: true,
            },
          })
          gsap.to('.layout-mobile-app__phone--fixed', {
            position: 'fixed',
            // left: '50%',
            // transform: 'translateX(-50%)',
            scrollTrigger: {
              trigger: '.layout-mobile-app__stores',
              start: 'bottom top',
              end: 'bottom top',
              scrub: true,
            },
          })
        },
      })
    })

    // const qrCode = Vue.ref(null)

    // function handler (entries) {
    //   console.log(entries[0].isIntersecting)

    //   if (!entries[0].isIntersecting) {
    //     qrCode.value.classList.add('is-hidden')
    //   } else {
    //     qrCode.value.classList.remove('is-hidden')
    //   }
    // }

    // const observer = new window.IntersectionObserver(handler, {
    //   rootMargin: '0px',
    //   threshold: 1.0,
    // })

    // observer.observe(document.querySelector('.header-sentinal'))

    return {
      isIOS,
      isAndroid,
      isOtherOS,
      accordions,
      showMoreButton,
      showMore,
      // qrCode,
    }
  },
})

const appElement = document.getElementById('mobile-app')

if (appElement) MobileApp.mount(appElement)
